import React from "react";
import { Routes, Route } from 'react-router-dom';
import { routes } from "../routes";
import AccessRouter from "./AccessRouter/AccessRouter";

const AppRouter = () => (
  <Routes>
    {routes.map(({ path, Component, isProtected, requireAccess }, index) => (
      <Route
        key={index}
        path={path}
        element={
          <AccessRouter
            component={Component}
            path={path}
            isProtected={isProtected}
            requireAccess={requireAccess}
          />
        }
      />
    ))}
  </Routes>
);

export default AppRouter;
